import axios from 'axios';
import { useEffect, useState } from 'react';
import LoadingGif from '../LoadingGif';
import moment from 'moment';
import { AuthContext } from '../../context/AuthContext';
import { useContext } from 'react';

const PressC = () => {
  const { postActivity } = useContext(AuthContext);
  const [PressCoverage, setPressCoverage] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [Next, setNext] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchPressC();
  }, []);

  const fetchPressC = () => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/press/post-get/?is_linkable=true&is_active=true`
      )
      .then((resp) => {
        // console.log(resp.data);
        setPressCoverage(resp.data.results);
        setLoading(false);
        setNext(resp.data.next);
      })
      .catch((error) => {
        // console.log(error.response);
        setLoading(false);
      });
  };

  const handlePagination = () => {
    postActivity('button', `Load More`, window.location.href);
    axios
      .get(Next)
      .then((resp) => {
        // console.log(resp.data);
        setPressCoverage([...PressCoverage, ...resp.data.results]);
        setNext(resp.data.next);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  return (
    <div className='press-r'>
      <h1 className='main-heading'>Press Coverage</h1>
      {Loading ? (
        <LoadingGif />
      ) : (
        <>
          <div className='cards'>
            {PressCoverage &&
              PressCoverage.map((press, i) => (
                <div
                  className='single'
                  key={i}
                  onClick={() =>
                    postActivity(
                      'card',
                      `Press Coverage (${press.name})`,
                      window.location.href
                    )
                  }
                >
                  <div className='rightt'>
                    <img src={press.image} alt='' width='255' height='163' />
                  </div>
                  <div className='leftt'>
                    <div className='date'>
                      <span className='source'>{press.source}</span>
                      <span className='dot'></span>
                      <span>{moment(press.date).format('DD MMM YYYY')}</span>
                    </div>
                    <div className='title'>
                      <a
                        href={press.link}
                        rel='noopener noreferrer'
                        target='_blank'
                      >
                        {press.name}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            {Next && (
              <div className='pagination-button'>
                <button
                  className='btn btn-light'
                  onClick={handlePagination}
                  disabled={Next ? '' : 'disabled'}
                >
                  Load More
                </button>
              </div>
            )}
          </div>
          {PressCoverage && PressCoverage.length === 0 ? (
            <p className='not-found'>Sorry, no press coverage found.</p>
          ) : (
            ''
          )}
        </>
      )}
    </div>
  );
};

export default PressC;
